import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom"; 
import Header from "./components/Header";
import WelcomeSection from "./components/WelcomeSection";
import ThemesSection from "./components/ThemesSection";
import AIDePINNetwork from "./components/AIDePINNetwork";
import AIDePINProvider from "./components/AIDePINProvider";
import AIDePINExplorer from "./components/AIDePINExplorer";
import PartnersSection from "./components/PartnersSection"; 
import Footer from "./components/Footer";
import WaveSeparator from "./components/WaveSeparator";
import Roadmap from "./components/Roadmap"; 
import Wallet from "./components/Wallet"; 
import Tokenomics from "./components/Tokenomics"; 

import './css/App.css';

// Fonction pour gérer le scroll
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // On force le scroll en haut de la page à chaque changement de route
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop /> {/* On place le ScrollToTop ici */}
        <Header />
        <Routes>
          <Route path="/" element={
            <>
              <WelcomeSection />
              <ThemesSection />
              <WaveSeparator />
              <AIDePINNetwork />
              <WaveSeparator />
              <AIDePINProvider />
              <WaveSeparator />
              <AIDePINExplorer />
              <WaveSeparator />
              <PartnersSection />
            </>
          } />
          <Route path="/wallet" element={<Wallet />} />
          <Route path="/roadmap" element={<Roadmap />} />
          <Route path="/tokenomics" element={<Tokenomics />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;